<template>
  <div class="project-box">
    <div class="tree-content">
      <div class="box">
        <div>
          <div class="header-box">
            <a-radio-group v-model="value" @change="onChange" button-style="solid" v-if="stList.length > 2">
              <a-radio-button value="1">区域</a-radio-button>
              <a-radio-button value="2">流域</a-radio-button>
            </a-radio-group>
            <a-radio-group v-model="category" @change="onCategoryChange" button-style="solid" v-else>
              <a-radio-button v-for="item in categoryList" :key="item.value" :value="item.value">{{
                item.title
              }}</a-radio-button>
            </a-radio-group>
            <!-- <a-button v-if="showSearchBox" type="primary" shape="circle" icon="search" @click="showSearch" />
            <a-button v-else shape="circle" icon="search" @click="showSearch" /> -->
          </div>

          <div style="padding: 10px 0" v-if="stList.length > 2">
            <a-select
              style="width: 265px"
              placeholder="请选择监测站点类型"
              v-model="st"
              @change="typeChange"
              :filterOption="filterOption"
              showSearch
            >
              <a-select-option v-for="(item, i) in stList" :key="i" :value="item.value">
                {{ item.title }}
              </a-select-option>
            </a-select>
            <!--<j-dict-select-tag-->
            <!--size="middle"-->
            <!--style="width: 100%"-->
            <!--dictCode="site_st"-->
            <!--v-model="st"-->
            <!--placeholder="请选择监测站点类型"-->
            <!--defaultValue='请选择监测站点类型'-->
            <!--@change="typeChange"-->
            <!--:triggerChange="true"-->
            <!--&gt;</j-dict-select-tag>-->
            <!-- <div style="padding:10px 0 0">
              <a-checkbox-group @change="onChange">
                <a-row>
                  <a-col :span="8">
                    <a-checkbox value="A">自动</a-checkbox>
                  </a-col>
                  <a-col :span="8">
                    <a-checkbox value="B">人工</a-checkbox>
                  </a-col>
                  <a-col :span="8">
                    <a-checkbox value="C">应急</a-checkbox>
                  </a-col>
                </a-row>
              </a-checkbox-group>
            </div>-->
          </div>
        </div>
        <div style="padding: 10px 0">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText" size="mini"></el-input>
          <el-tree
            style="margin-top: 10px; height: calc(89vh - 170px); overflow-y: auto"
            ref="tree"
            :data="treeData"
            :default-expanded-keys="expandedKeys"
            node-key="key"
            :current-node-key="currentKey"
            :render-content="renderContent"
            :filter-node-method="filterNode"
            :props="defaultProps"
            :highlight-current="true"
            @node-click="onSelect"
          >
          </el-tree>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { querySiteTree, getTenantStByToken, ajaxGetDictItems } from '@/api/api'
import eventBus from '@/utils/eventBus.js'
export default {
  name: 'siteSelect',
  data() {
    return {
      category: '',
      categoryList: [],
      value: '1',
      st: '',
      stList: [],
      showSearchBox: false,
      filterText: '',
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      treeData: [],
      checkedKeys: [],
      expandedKeys: [],
      currentKey: '',
      siteId: '',
    }
  },
  props: {},
  created() {
    this.getCategoryList()
    var that = this
    window.addEventListener('setItem', (e) => {
      if (e.key == 'siteId') {
        this.siteId = sessionStorage.getItem('siteId')
      }
    })
    this.getTenantStList()
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    },
  },
  methods: {
    getCategoryList() {
      ajaxGetDictItems('site_st52_category', null).then((res) => {
        if (res.success) {
          this.categoryList = res.result
        }
      })
    },
    getTenantStList() {
      getTenantStByToken().then((res) => {
        if (res.success) {
          if (res.result && res.result.length > 0) {
            this.stList = res.result
            this.stList.unshift({
              value: '',
              title: '请选择监测站点类型',
              text: '请选择监测站点类型',
            })
            if (res.result.length < 2) {
              this.typeChange(res.result[0].value)
            }
          }
        } else {
          this.stList.unshift({
            value: '',
            title: '请选择监测站点类型',
            text: '请选择监测站点类型',
          })
        }
        if (sessionStorage.getItem('selectTreeCategory')) {
          this.category = sessionStorage.getItem('selectTreeCategory')
          sessionStorage.setItem('selectTreeCategory', '')
        } else {
          if (this.stList.length <= 2) {
            this.category = '3'
          } else {
            this.category = ''
          }
        }

        this.loadTree(this.value, this.st, this.category)
      })
    },
    // 类型字典变化
    typeChange(val) {
      this.st = val
      this.loadTree(this.value, val, this.category)
    },
    // 过滤节点
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    // 显示搜索条件
    showSearch() {
      this.showSearchBox = !this.showSearchBox
    },
    handleChange(value) {},
    onChange(e) {
      this.loadTree(e.target.value, this.st, this.category)
    },
    onCategoryChange(e) {
      console.log(`checked = ${e.target.value}`)
      this.loadTree(this.value, this.st, e.target.value)
    },
    // 自定义图标
    renderContent(h, { node, data, store }) {
      var icon
      if (data.data && data.data.st) {
        switch (data.data.st) {
          case '31':
            icon = 'icon-feiqi'
            break
          case '32':
            icon = 'icon-yiliaofeishui'
            break
          case '35':
            icon = 'icon-turang'
            break
          case '21':
            icon = 'icon-shuizhijiancezhan'
            break
          case '22':
            icon = 'icon-kongqijiance'
            break
          case '61':
            icon = 'icon-shuikushuiwenzhan'
            break
          case '52':
            icon = 'icon-yiliaofeishui'
            break
        }
      }
      var rex = /^[a-zA-Z]/
      // if (data.total == 0 && rex.test(data.key[0])) {
      // } else {
      return (
        <span class="custom-tree-node">
          <span
            v-show={data.isLeaf && !rex.test(data.key[0])}
            title={
              node.label +
              '\n' +
              (data.online ? '在线' : '离线') +
              (data.data.currentStandard ? '，' + data.data.currentStandard.title : '') +
              (data.data.upStandard === 'true' ? '，达标' : data.data.upStandard === null ? '' : '，不达标') +
              (data.data.lastTime ? '\n' + data.data.lastTime : '')
            }
            style="display:flex;align-items:center;"
          >
            <div v-show={data.online} style="font-size:0.7rem;margin-right:3px;" class={'iconfont ' + icon}></div>
            <div
              v-show={!data.online}
              style="font-size:0.7rem;margin-right:3px;color:gray;"
              class={'iconfont ' + icon}
            ></div>
            {node.label.length > this.testLength - 2 ? node.label.slice(0, this.testLength - 2) + '...' : node.label}
          </span>
          <span v-show={!data.isLeaf}>
            {node.label}({data.onlineNum}/{data.total})
          </span>
          <div
            v-show={data.data.currentStandard && data.isLeaf}
            style={{
              'font-size': '0.6rem',
              height: '20px',
              'line-height': '20px',
              padding: '0px 5px',
              'border-radius': '5px',
              position: 'absolute',
              right: '0',
              top: '3px',
              color: '#000',
              'background-color': data.data.currentStandard ? data.data.currentStandard.color : 'gray',
            }}
          >
            {data.data.currentStandard ? data.data.currentStandard.title : ''}
          </div>
          <div
            v-show={!data.data.currentStandard && data.isLeaf && data.data.upStandard === 'true'}
            style="font-size:0.6rem;height:20px;line-height: 20px;padding:0px 5px;border-radius:5px;position:absolute;right:0;top:3px;background-color:green;color:#fff;"
          >
            达标
          </div>
          <div
            v-show={!data.data.currentStandard && data.isLeaf && data.data.upStandard === 'false'}
            style="font-size:0.6rem;height:20px;line-height: 20px;padding:0px 5px;border-radius:5px;position:absolute;right:0;top:3px;background-color:red;color:#fff;"
          >
            不达标
          </div>
        </span>
      )
      // }
    },
    getLast(list) {
      // debugger
      let ids = {}
      if (sessionStorage.getItem('selectId')) ids = JSON.parse(sessionStorage.getItem('selectId'))
      if (ids.id) {
        let areaKey
        // if (ids.companyId) {
        //   areaKey = 'C_' + ids.companyId
        //   list.forEach((items, indexs) => {
        //     this.expandedKeys.push(items.key)
        //     items.children.forEach((item1, index1) => {
        //       this.expandedKeys.push(item1.key)
        //     })
        //   })
        // } else {
          areaKey = 'A_' + ids.areaId
          list.forEach((items, indexs) => {
            this.expandedKeys.push(items.key)
          })
        // }

        this.expandedKeys.push(areaKey)
        this.expandedKeys.push(ids.id)
        this.siteId = ids.id
        this.resetSetItem('siteId', ids.id)
        this.resetSetItem('siteName', ids.name)
        this.resetSetItem('siteType', ids.st)
        this.$emit('selectSite', {
          siteId: ids.id,
          siteName: ids.name,
          siteType: ids.st,
          category: this.category,
        })
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.siteId)
        })
        sessionStorage.setItem('selectId', [])
      } else {
        if (list[0].children && list[0].children.length > 0) {
          this.getLast(list[0].children)
          this.expandedKeys.push(list[0].key)
        } else {
          var siteObj = list[0]
          this.resetSetItem('siteId', siteObj.key)
          this.resetSetItem('siteName', siteObj.title)
          this.resetSetItem('siteType', siteObj.data.st)
          this.siteId = siteObj.key
          this.$emit('selectSite', {
            siteId: siteObj.key,
            siteName: siteObj.title,
            siteType: siteObj.data.st,
            category: this.category,
          })
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(this.siteId)
          })
        }
      }
    },
    loadTree(addrType, st, category) {
      var that = this
      st = 32
      querySiteTree({
        addrType,
        st,
        category,
      }).then((res) => {
        if (res.success) {
          that.treeData = res.result
          that.getLast(that.treeData)
        }
      })
    },
    onSelect(data,node) {
      if (data.isLeaf) {
        this.siteId = data.key
        var rex = /^[a-zA-Z]/
        if (!rex.test(data.key[0])) {
          this.$nextTick(() => {
            this.resetSetItem('siteId', data.key)
            this.resetSetItem('siteName', data.title)
            this.resetSetItem('siteType', data.data.st)
            this.resetSetItem('fullName', '')
            this.resetSetItem('siteAreaName', node.parent.data.label)
            this.resetSetItem('siteAreaId', node.parent.data.key)
            this.$emit('selectSite', {
              siteId: data.key,
              siteName: data.title,
              siteType: data.data.st,
              category: this.category,
            })
            this.currentKey = this.siteId
          })
        }
      }
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  },
}
</script>


<style lang="scss" scoped>
.project-box {
  height: 89vh;
  display: flex;
  align-items: center;
  padding: 10px 5px 10px 10px;
  overflow-y: hidden;
  .tree-content {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .box {
      width: 295px;
      height: 100%;
      padding-right: 10px;
      overflow-y: hidden;
      .header-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      ::v-deep .ant-radio-button-wrapper {
        background: transparent;
        color: #1890ff;
        border-color: #1890ff;
      }
      ::v-deep .ant-radio-button-wrapper-checked {
        color: #fff !important;
        background: #1890ff;
        border-color: #1890ff !important;
      }
      ::v-deep .el-input__inner {
        background-color: transparent;
        border-color: #1890ff;
      }
      ::v-deep .ant-btn {
        background-color: transparent !important;
        color: #1890ff;
        border-color: #1890ff;
      }
      ::v-deep .ant-btn-primary {
        background-color: #1890ff !important;
        color: #fff;
        border-color: #1890ff;
      }
      ::v-deep .ant-select-selection {
        background-color: transparent;
        color: #dcdfe6;
        font-size: 0.6rem;
        border-color: #1890ff;
      }
      ::v-deep .ant-select-selection--single {
        height: 29px;
      }
      ::v-deep .ant-select-selection__rendered {
        line-height: 29px;
      }
      ::v-deep .ant-select-arrow {
        color: #1890ff;
      }
      .el-tree {
        background-color: transparent;
        color: #1890ff;
        ::v-deep .el-tree-node.is-current > .el-tree-node__content {
          background-color: #1890ff !important;
          color: #fff !important;
        }
        ::v-deep .el-tree-node__content {
          display: inline-block;
          width: 100%;
          position: relative;
          .custom-tree-node {
            display: inline-block;
            height: 100%;
            line-height: 27px;
          }
          &:hover {
            background-color: #1890ff !important;
            color: #fff !important;
          }
        }
      }
      .box-top {
        width: 100%;
        height: 40px;
        padding: 0 10px;
        border-bottom: 1px solid #eee;
      }
      .box-bottom {
        box-sizing: border-box;
        height: calc(100% - 40px);
        overflow-y: hidden;
        padding: 10px 0;
        .list-item {
          width: calc(100% - 5px);
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          height: 30px;
          line-height: 30px;
          padding: 0 10px;
          cursor: pointer;
          &:hover {
            background-color: #1890ff;
            color: #fff;
          }
          &.active {
            background-color: #1890ff;
            color: #fff;
          }
        }
      }
    }
  }
}
::-webkit-scrollbar {
  display: none;
}
</style>